import { CaretUpOutlined } from '@ant-design/icons'

import { useStyles } from './styles'

type ExpandIconProps = {
  isActive?: boolean
}

export const CollapseExpandArrow = ({ isActive }: ExpandIconProps) => {
  const { styles } = useStyles({ isActive })

  return <CaretUpOutlined className={styles.collapseArrow} />
}
